import * as bootstrap from 'bootstrap';
import Chart from 'chart.js/auto';

import.meta.glob([
    '../img/**'
]);

window.Chart = Chart;

class App {
    constructor() {
        this.init();
    }

    init() {
        this.initTooltips();
        this.autoModals();
        this.toggleFields();
        this.categorySelection();
    }

    initTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

        [...tooltipTriggerList].map(tooltipTriggerEl => {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                customClass: 'questionnaire__tooltip',
                boundary: 'window',
                offset: [0, 10],
            });
        });
    }

    autoModals() {
        document.querySelectorAll('.modal-auto').forEach(modal => {
            bootstrap.Modal.getOrCreateInstance(modal).show();
        })
    }

    /**
     * Toggle field visibility
     *
     */
    toggleFields () {
        document.querySelectorAll('[data-toggle-by]').forEach(element => {
            let toggleName = element.dataset.toggleBy;
            let toggleValue = element.dataset.toggleValue;

            let target = document.querySelector('[name="' + toggleName + '"]');

            // Determine the element type
            let eventType = (target.type === 'checkbox' || target.type === 'radio') ? 'change' : 'change';

            target.addEventListener(eventType, function () {
                let targetValue;

                // For checkboxes, the value depends on whether it is checked or not
                if (target.type === 'checkbox') {
                    targetValue = this.checked ? this.value : '';
                }
                // For radio buttons, get the selected value
                else if (target.type === 'radio') {
                    targetValue = document.querySelector('input[name="' + toggleName + '"]:checked')?.value || '';
                }
                // For other input types, like select
                else {
                    targetValue = this.value;
                }

                // Toggle element visibility based on the value
                element.style.display = toggleValue.split('|').includes(targetValue) ? 'block' : 'none';
            });

            // Manually create and dispatch the event
            let event = new Event('change');

            target.dispatchEvent(event);
        });
    }

    categorySelection() {
        const form = document.getElementById('form-category-selection');

        if (form === null) {
            return;
        }

        const buttonSubmit = form.querySelector('button[type="submit"]');

        const inputCategoryId = form.querySelector('input[name="questionnaire_category_id"]');

        form.querySelectorAll('.questionnaire__categories-item:not(.questionnaire__categories-item--disabled)').forEach(category => {
            category.addEventListener('click', (event) => {
                event.preventDefault();
                const target = event.currentTarget;

                const categoryId = target.getAttribute('data-category-id');

                if (categoryId) {
                    inputCategoryId.value = categoryId;

                    // Remove active class from all categories
                    form.querySelectorAll('.questionnaire__categories-item:not(.questionnaire__categories-item--disabled)').forEach(item => {
                        item.classList.remove('questionnaire__categories-item--active');
                    });

                    // Add active class to the clicked category
                    target.classList.add('questionnaire__categories-item--active');

                    buttonSubmit.disabled = false;
                }
            });
        });
    }
}

window.addEventListener('load', () => new App());
